import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { defer, Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '@src/environments/environment';
import { GenericResponse } from '@app/models/backend';
import { UserResponse } from '@app/store/user/user.models';

export interface EventoUsuario {
  id: string;
  fecha: string;
  fecha_fin: string | null;
  actor_id: number;
  actor_nombre: string;
  actor_rol: string;
  actor_sede_id: number;
  usuario_id: number;
  usuario_nombre: string;
  operacion: string;
  resultado: 'PENDIENTE' | 'CONFIRMADO' | 'FALLO' | 'INCIERTO';
  anterior: Record<string, any>;
  nuevo: Record<string, any> | null;
  cambios: { campo: string; anterior: any; nuevo: any }[];
  motivo: string | null;
}

export interface HistorialUsuarios {
  data: EventoUsuario[];
  total: number;
  page: number;
  size: number;
  totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class AuditoriaUsuariosService {
  private readonly url = environment.urlAsistencias + 'sgs-observabilidad/api/usuarios-auditoria/';
  constructor(private http: HttpClient) {}

  get puedeConsultar(): boolean {
    try {
      const rol = JSON.parse(localStorage.getItem('user') || '{}').role;
      return ['ADMIN', 'SUPERADMIN', 'PROGRAMADOR', 'LECTOR', 'MARKETING', 'RECURSOSHUMANOS'].includes(rol);
    } catch { return false; }
  }

  actualizar(id: number, datos: any): Observable<GenericResponse<UserResponse>> {
    // Identifica la operación; un resultado incierto no se reintenta automáticamente.
    return defer(() => this.http.put<GenericResponse<UserResponse>>(this.url + 'usuarios/' + id, datos, {
      headers: { 'X-Operacion-Id': uuidv4() }
    }));
  }

  desactivar(id: number): Observable<GenericResponse<string>> {
    return defer(() => this.http.delete<GenericResponse<string>>(this.url + 'usuarios/' + id, {
      headers: { 'X-Operacion-Id': uuidv4() }
    }));
  }

  historial(filtros: Record<string, any>): Observable<HistorialUsuarios> {
    let params = new HttpParams();
    Object.entries(filtros).forEach(([clave, valor]) => {
      if (valor !== null && valor !== undefined && valor !== '') params = params.set(clave, String(valor));
    });
    return this.http.get<HistorialUsuarios>(this.url + 'historial', { params });
  }
}
